// extracted by mini-css-extract-plugin
export default {"editMenu":"EditMenu_editMenu__15+RD","listItem":"EditMenu_listItem__R-7P2","disabled":"EditMenu_disabled__1o3BS","link":"EditMenu_link__B+HN3"};